import { Box } from '@mui/material';
import { KpiStructureConfigureButton } from './KpiStructureConfigureButton';
import { AllStructuresForHomePageQuery } from '@/__generated__/graphql';
import { KpiIntervalFilterButton } from './KpiIntervalFilterButton';
import { KpiDateRangeFilterButton } from './KpiDateRangeFilterButton';
import { KpiWorkpackTypeFilterButton } from './KpiWorkpackTypeFilterButton';
import { KpiWbsFilterButton } from './KpiWbsFilterButton';

type Props = {
  deployments: AllStructuresForHomePageQuery['allStructures'];
};

const rootStyles = {
  display: 'flex',
  mt: 2,
  gap: 1,
  // First child gets pushed to the end
  '& > :first-child': {
    ml: 'auto',
  },
} as const;

export const KpiFilters = ({ deployments }: Props) => {
  return (
    <Box sx={rootStyles}>
      <KpiWbsFilterButton />
      <KpiWorkpackTypeFilterButton />
      <KpiIntervalFilterButton />
      <KpiDateRangeFilterButton />
      <KpiStructureConfigureButton deployments={deployments} />
    </Box>
  );
};
